export default "__VITE_ASSET__yPHuwoaA__"